import { createContext, useEffect, useState, useContext, useMemo } from "react";
import { IAuthProvider, IContext, IUser } from "./types";
import {
  setAccessTokenLocalStorage,
  setUserAuthLocalStorage,
  handleUserLogOut,
} from "./utils";
import { LoginRequest } from "../services/UserAuthService";
import { saveEncryptedCredentials, UserCredentials, clearEncryptedCredentials } from "../utils/cryptoUtils";

import { UserPreferenceContext } from "../context/UserPreferenceContext";
import {
  IsAuthenticated,
  checkUserIsLogged,
  handleDisconnectedUserAux,
} from "./AuthProviderUtils";

export const AuthContext = createContext<IContext>({} as IContext);

export const AuthProvider = ({ children }: IAuthProvider) => {
  const [user, setUser] = useState<IUser | null>({
    rememberLogin: false,
    tosAgree: false,
  });
  const [isAutoLoginLoading, setIsAutoLoginLoading] = useState<boolean>(false);
  const { userPreference, userAuthenticated, setUserAuthenticated, doUserPreference } =
    useContext(UserPreferenceContext);
  useEffect(() => {
    const initializeAuth = async () => {
      await checkUserIsLogged(setUser, userAuthenticated, setUserAuthenticated, setIsAutoLoginLoading);
      if (userPreference == null && userAuthenticated) {
        doUserPreference();
      }
    };
    
    initializeAuth();
  }, [userAuthenticated]);

  async function authenticate(
    username: string,
    password: string,
    countryId: number,
    language: string,
    rememberLogin: boolean,
    tosAgree: boolean
  ) {
    const response = await LoginRequest(
      username,
      password,
      countryId,
      language
    );
    localStorage.removeItem('passwordChangeRedirected');
    if (response) {
      const payload: IUser = {
        username: response.userName,
        rememberLogin: rememberLogin,
        tosAgree: rememberLogin ? true : tosAgree,
        //password: password,
      };
      if (
        response?.access_token !== null &&
        response?.access_token !== undefined &&
        response?.access_token !== ""
      ) {
    
        const credentials: UserCredentials = {
          username,
          password,
          countryId,
          language,
          rememberLogin,
          tosAgree: rememberLogin ? true : tosAgree,
        };
        saveEncryptedCredentials(credentials);

        setAccessTokenLocalStorage(response.access_token);
        setUserAuthLocalStorage(payload);
        setUser(payload);
        await doUserPreference();
        setUserAuthenticated(true);
      }
    }

    return response;
  }

  function logout() {
    setUser(null);
    clearEncryptedCredentials(); 
    handleUserLogOut();
  }

  function setUserAuth(user: IUser) {
    setUser(user);
  }

  function handleDisconnectedUser(data: any, userIsAuthenticated: boolean) {
    let objParam = {
      data,
      userAuthenticated,
      userIsAuthenticated,
      setUser,
      setUserAuthenticated,
      user,
      userPreference,
    };
    handleDisconnectedUserAux(objParam);
  }

  const objMemoProvider = useMemo(
    () => ({
      ...user,
      authenticate,
      logout,
      setUserAuth,
      IsAuthenticated,
      handleDisconnectedUser,
      isAutoLoginLoading,
    }),
    [user, isAutoLoginLoading]
  );

  return (
    <AuthContext.Provider value={objMemoProvider}>
      {children}
    </AuthContext.Provider>
  );
};